import BottomBar from "@components/BottomBars/BottomBar";
import PennyInput from "@components/Inputs/PennyInput";
import SectionHeader from "@components/Section/SectionHeader";
import SectionHeaderTitle from "@components/Section/SectionHeaderTitle";
import Footer from "@components/layout/Footer";
import Loading from "@components/layout/Loading";
import { useCurrentUserMutation, useGetUser } from "@utils/hooks";
import PensionCard from "@view/pension_application/PensionCard";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type ActivityInformationProps = {};

const ActivityInformation: React.FC<ActivityInformationProps> = () => {
  const { data, isLoading } = useGetUser();
  const {
    mutate,
    isLoading: mutateLoading,
    isSuccess: mutateSuccess,
  } = useCurrentUserMutation();
  const navigate = useNavigate();

  const handleSubmitActivityInformation = () => {
    mutate({
      pension_applied_activity_information: true,
    });
  };

  useEffect(() => {
    if (!mutateLoading && mutateSuccess) {
      navigate("success");
    }
  }, [mutateSuccess, mutateLoading, navigate]);

  if (isLoading || mutateLoading) return <Loading />;

  return (
    <section>
      <SectionHeaderTitle label="Your application summary" />

      <div>
        <SectionHeader label="Your Pension" />
        <div className="px-4 pb-4">
          <PensionCard
            pensionApplied={data?.pension_applied}
            contribution={210}
          />
        </div>
      </div>

      <div>
        <SectionHeader label="Your Details" />
        <div className="px-4 pb-4">
          <div className="bg-pn_white border border-pn_gray-200 rounded-2xl p-6 flex flex-col gap-y-4">
            <PennyInput
              label="Full Name"
              className="select-none pointer-events-none"
              value={data?.first_name + " " + data?.last_name}
            />
            <PennyInput
              label="Date of Birth"
              className="select-none pointer-events-none"
              value={data?.birth_date}
            />
            <PennyInput
              label="Nationality"
              className="select-none pointer-events-none"
              value={data?.nationality}
            />
            <PennyInput
              label="PPS Number"
              className="select-none pointer-events-none"
              value={data?.pps_number}
            />
            <PennyInput
              label="PEP Status (Politically exposed person)"
              className="select-none pointer-events-none"
              value={data?.first_name + " " + data?.last_name}
            />
          </div>
        </div>
      </div>

      <div>
        <SectionHeader label="Contact Details" />
        <div className="px-4 pb-4">
          <div className="bg-pn_white border border-pn_gray-200 rounded-2xl p-6 flex flex-col gap-y-4">
            <PennyInput
              label="Email Address"
              className="select-none pointer-events-none"
              value={data?.email_address}
            />
            <PennyInput
              label="Phone"
              className="select-none pointer-events-none"
              value={data?.phone_number}
            />
            <PennyInput
              label="Eircode"
              className="select-none pointer-events-none"
              value={data?.pps_number}
            />
          </div>
        </div>
      </div>

      <BottomBar
        layout="main_back"
        onBack={() => navigate(-1)}
        onNext={handleSubmitActivityInformation}
        labelNext="Submit"
      />

      <Footer />
    </section>
  );
};
export default ActivityInformation;
